import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IDac6ReporterState } from '../../store/reducers/dac6-reporter.reducer';
import { ParticleState } from '@shared/store/reducers/particle.reduer';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogService } from '@shared/services/dialog-service';
import {ExportDAC6Command, UpdateCountriesCommand} from '../../commands/dac6-reporter.command';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {FileManagementService} from "@core/services/file-management.service";
import {DownloadGlobalResourceCommand} from "../../../file-manager/commands/create-directory.command";


@Component({
    standalone: false,
    selector: 'particle-countries-content',
  templateUrl: './countries-content.component.html',
  styleUrls: ['./countries-content.component.scss']
})
export class CountriesContentComponent implements OnInit , OnDestroy {

  sourceType: string;
  currentSelectedItems: string[];
  flag: boolean;
  deleteDisabled: boolean;
  unSubscribe$ = new Subject<void>();
  invalidateSubject: InvalidateSubject;

  constructor( private router: Router,  private store: Store<IDac6ReporterState>,
               private particleStore: Store<ParticleState>,
               protected commandService: CommandService,
               private activatedRoute: ActivatedRoute,
               private snackBarService: SnackBarService,
               private dialogService: DialogService,
               private fuseSplashScreenService: FuseSplashScreenService,
               private fileManagementService: FileManagementService
  ) {
    this.sourceType = 'DAC6_Country';
    this.invalidateSubject = new InvalidateSubject();

  }

  ngOnInit() {
    this.currentSelectedItems = [];
    this.flag = false;
    this.deleteDisabled = true;
  }
  onCellEditorClosed (event) {
    console.log(event);
    this.router.navigate(['']);
  }
  onSelectionChanged(event) {
    if (this.flag) {
      this.currentSelectedItems = [];
    }
    this.flag = false;
    event.deselectedRows.forEach(item => {
      const index = this.currentSelectedItems.indexOf(item.dataItem.id);
      if (index > -1) {
        this.currentSelectedItems.splice(index, 1);
      }
    });
    event.selectedRows.forEach(item => {
      this.currentSelectedItems.push(item.dataItem.id);
    });
    if (this.currentSelectedItems.length > 0) {
      this.deleteDisabled = false;
    } else {
      this.deleteDisabled = true;
    }

  }
  addSection() {
    this.router.navigate(['/add-section/' + this.sourceType], {relativeTo: this.activatedRoute});
  }
  manageSection() {
    this.router.navigate(['/manage-section/' + this.sourceType], {relativeTo: this.activatedRoute});
  }
  exportTransaction() {

  }

  onGridCellValueChange(event) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'ArrangementCode') {
      this.router.navigate(['.', event.item.id], {relativeTo: this.activatedRoute});
      return;
    }
    if(event.action){
      switch(event.action.id){
        case 'Open':
          break;
        case 'Edit':
          this.edit(event);
          break;
      }
    }
    console.log(event);
  }
  edit(event: any) {

    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition)
      .subscribe(state=>{
        console.log('After Edit', state);
        if(state.action==='OK'){
          const item = {id: event.item.id, fieldValues: {}};
          const value = event.item.cells[event.fieldDefinition.key].value;
          item.fieldValues[event.fieldDefinition.key]=value;
          console.log(item);
          const command = new UpdateCountriesCommand(item);
          this.commandService.executeCommand(command).pipe().subscribe(commandState=>{
            console.log(commandState);
            this.invalidateSubject.invalidate();
          });
        }
      });
  }
  export() {
    this.fuseSplashScreenService.show();
    const command = new DownloadGlobalResourceCommand('Root/DAC6/DownloadHallmarkCountries/Hallmark-Countries.xlsx');
    this.commandService.executeCommand(command).pipe().subscribe(data => {
      console.log('Download File', data);
      this.fuseSplashScreenService.hide()
      this.fileManagementService.downloadOneTimeSignedUrl(data.Payload['DownloadUrl'], data.Payload['FileName']);
    });
    /*const sourceType = 'Dac6Country';
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new ExportDAC6Command(sourceType)).subscribe(response => {
      this.fileManagementService.downloadClientFileWithId(response.Payload.FileId).subscribe(payload => {
        this.fuseSplashScreenService.hide();
        const exportFileName = response.Payload.FileName;
        if (exportFileName === 'DAC6_Hallmark_Countries.xlsx') {

        } else {
          this.fileManagementService.openSaveFileWindow(payload, exportFileName);
        }
      }, () => this.fuseSplashScreenService.hide() );
    }, () => this.fuseSplashScreenService.hide() );*/
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }


}
